import {merchantLocalStorage} from "../../merchant-state/MerchantStorage.js";
import {MERCHANT_STORAGE_KEYS} from "../../../Constants.js";

const PAGE_VISITS_MAX_ENTRIES = 50;

export function loadPageVisitsMap() {
    const pageVisitsMap = new Map();
    const initialState = merchantLocalStorage.getItem(MERCHANT_STORAGE_KEYS.pageVisits);
    for (const entry of (initialState || {}).v || []) {
        pageVisitsMap.set(entry[0], entry[1]);
    }
    return pageVisitsMap;
}

export function updatePageVisit(href, metadata) {
    const pageVisitsMap = loadPageVisitsMap();
    let path;
    try {
        const url = new URL(href);
        path = url.pathname.endsWith("/") ? url.pathname : url.pathname + "/";
    } catch {
        // Assume this is already a path.
        path = String(href);
    }

    const now = Date.now();
    const currentVisit = {
        ...pageVisitsMap.get(path),
        ...metadata,
        lastVisit: now,
    };
    if (!currentVisit.firstVisit) {
        currentVisit.firstVisit = now;
    }

    // Add to the set and maybe clean it if there are too many entries
    pageVisitsMap.set(path, currentVisit);
    if (pageVisitsMap.size > PAGE_VISITS_MAX_ENTRIES) {
        const newEntries = [...pageVisitsMap]
            .sort((a, b) => b[1].lastVisit - a[1].lastVisit) // sort descending by timestamp
            .slice(0, PAGE_VISITS_MAX_ENTRIES); // keep the most recent
        pageVisitsMap.clear();
        for (const entry of newEntries) {
            pageVisitsMap.set(entry[0], entry[1]);
        }
    }
    merchantLocalStorage.setItem(MERCHANT_STORAGE_KEYS.pageVisits, {
        v: [...pageVisitsMap.entries()],
    });
    return [currentVisit, pageVisitsMap];
}

export function isURLViewed(url) {
    let path = url;
    try {
        url = new URL(url);
        path = url.pathname;
    } catch {
    }
    if (isPathEqual(path, location.pathname)) {
        // The current page is considered viewed.
        return true;
    }

    const pageVisitsMap = loadPageVisitsMap();
    for (const visitedPath of pageVisitsMap.keys()) {
        if (isPathEqual(path, visitedPath)) {
            return true;
        }
    }
    return false;
}

export function isPathEqual(a, b) {
    return a === b || a === (b + "/") || (a + "/") === b;
}
